export default {"src":"/_next/static/media/home-paint-icon.dcf22564.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};